import Button from '../../../../UI/Button/Button';
import Translation from '../../../lang/Translation';
import useStyles from './CurrentLocation.styles';
import NearMe from '../../ui/svg/Components/NearMeIcon';

export function CurrentLocation() {
  const classes = useStyles();
  
  return (
    <div className={classes.currentLocation}>
      <Button
        textOnly
        leftAlign
        noStyle
        id="currentLocation"
        icon={<NearMe />}
      >
        <Translation>pudo.currentLocation</Translation>
      </Button>
    </div>
  );
}

export default CurrentLocation;
